//@ts-ignore
import AnnouncementIcon from "@mui/icons-material/Announcement";
import { useAppSelector } from "../../redux/store";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";

const ChatMessages = () => {
  const notices = useAppSelector((state) => state.notices);

  return (
    <div className="bg-gray-100 p-4 rounded-lg space-y-3">
      <h3 className="font-bold text-center">Ihre früheren Anfragen:</h3>

      {notices.notices.length > 0 &&
        notices.notices.map((notice, i) => {
          return (
            <div
              key={i}
              className="bg-white p-2 rounded-lg border-t-2  border-t-third space-y-3"
            >
              <div className="text-gray-400 ">
                <div className="flex justify-between pb-2 mb-2 border-b-2 border-b-gray font-bold">
                  <h3>
                    <LiveHelpIcon className="text-third" /> Ihre Anfrage
                  </h3>
                  <h3>Vom {notice.noticeTime}</h3>
                </div>
                <p>{notice.notice}</p>
              </div>

              <div>
                <div className="flex justify-between pb-2 mb-2 border-b-2 border-b-third font-bold">
                  <h3>
                    <AnnouncementIcon className="text-third" /> LMX
                    Servicecenter Antwort
                  </h3>

                  {notice.commentTime && <h3>Vom {notice.commentTime}</h3>}
                </div>
                <p>{notice.comment}</p>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default ChatMessages;
